import React from "react";
import { ErrorBoundary } from "@sscs/ui";
import FileChanges from "../diff/filesDiff/FileChanges";
const ReproModifiedFilesTab = () => (React.createElement(ErrorBoundary, { key: "file-changes" },
    React.createElement(FileChanges, null)));
export default ReproModifiedFilesTab;
//# sourceMappingURL=ReproModifiedFilesTab.js.map